import { render, staticRenderFns } from "./PartnerPrice.vue?vue&type=template&id=97bac96e&scoped=true"
import script from "./PartnerPrice.vue?vue&type=script&lang=js"
export * from "./PartnerPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bac96e",
  null
  
)

export default component.exports